<template>
  <section class="section has-background-light fullheight-min">
    <div class="container " >

      <!-- breadcrumbs -->
      <slot></slot>

      <!-- title page -->
      <h2 class="title">
        <a href="#" @click.prevent="$router.go(-1)" title="назад">
          <span class="icon" style="margin-right:0.5em;"><i class="fas fa-arrow-circle-left"></i></span>
        </a>
        Просмотр {{ $tc($route.params.model, 0) }}
      </h2>
      <div class="content">
        <p class="subheader"><strong>Выбрать и снять выделение</strong> можно кликнув по соответствующей строке</p>
        <p class="subheader"><strong>Двойным</strong> кликом можно <strong>открыть запись</strong></p>
      </div>

      <!-- content -->
      <div class="content">
        <input type="checkbox" class="switch is-rounded" id="mobile-view" v-model="mobile">
        <label for="mobile-view">Мобильный вид</label>
      </div>
      <div class="table-container" >
        <div class="hero" v-if="loading">
          <div class="hero-body">
            <div class="container has-text-centered">
              <span class="icon is-large">
                <i class="fas fa-spinner fa-pulse fa-3x has-text-grey"></i>
              </span>
            </div>
          </div>
        </div>
        <Table
          v-else
          :theader="filteredData[0] && Object.keys(filteredData[0])"
          :tdata="filteredData"
          :selected.sync="selected"
          class="is-hoverable is-striped transparent"
          style="min-width:100%;"
        ></Table>
      </div>

      <!-- пагинация - покажем, если число записей больше limit -->
      <nav class="pagination" role="navigation" aria-label="pagination" v-if="count > limit">
        <a class="pagination-previous" @click.prevent="prevPage" v-if="page > 1">Назад</a>
        <a class="pagination-next" @click.prevent="nextPage" v-if="count > page * limit">Дальше</a>
        <ul class="pagination-list">
          <template v-if="page > 2">
            <li>
              <router-link :to="{query: {page: 1}}" class="pagination-link" aria-label="Goto page 1">1</router-link>
            </li>
            <li>
              <span class="pagination-ellipsis">&hellip;</span>
            </li>
          </template>
          <li>
            <router-link :to="{query: {page: page - 1}}" class="pagination-link" :aria-label="`Goto page ${page - 1}`" v-if="page > 1">{{page - 1}}</router-link>
          </li>
          <li>
            <router-link :to="{query: {page}}" class="pagination-link is-current" :aria-label="`Page ${page}`" aria-current="page">{{page}}</router-link>
          </li>
          <li>
            <router-link :to="{query: {page: page + 1}}" class="pagination-link" :aria-label="`Goto page ${page + 1}`" v-if="page * limit < count">{{page + 1}}</router-link>
          </li>
          <template v-if="(page + 1) * limit <= count">
            <li>
              <span class="pagination-ellipsis">&hellip;</span>
            </li>
            <li>
              <router-link :to="{query: {page: Math.ceil(count / limit)}}" class="pagination-link" :aria-label="`Goto page ${Math.ceil(count / limit)}`">{{ Math.ceil(count / limit) }}</router-link>
            </li>
          </template>
        </ul>
      </nav>

      <!-- выбранные строки в виде тегов -->
      <div class="tags" v-if="selected.length > 0">
        <span class="tag">Выбрано:</span>
        <span class="tag is-primary" v-for="(tag, index) in selected" :key="index">
          {{tag.pk || tag.id}}
          <button class="delete is-small" @click="selected.splice($_.findIndex(selected, tag), 1)"></button>
        </span>
        <a class="tag is-danger" @click="selected = []">очистить</a>
      </div>

      <!-- кнопки действия, если что то выбрано + кнопка создать -->
      <div class="buttons">
        <template v-if="selected.length > 0">
          <!-- <button class="button" v-if="selected.length < 2">Изменить</button> -->
          <button class="button is-danger is-outlined" @click="deleteSelected">Удалить</button>
        </template>
        <router-link to="create" append class="button is-primary">Создать</router-link>
      </div>

      <!-- подсказка при удалении -->
      <transition-group enter-active-class="animated fadeIn" leave-active-class="animated fadeOut"  >
        <div :class="`notification ${status.class}`" v-for="(status, key, id) in statuses" :key="key" :id="key+id">
          <button class="delete" @click="$delete(statuses, key)"></button>
          {{status.message}}
        </div>
      </transition-group>
    </div>
  </section>
</template>
<script>
export default {
  components: {
    Table: () => import('@/components/Table.vue')
  },
  data () {
    return {
      tdata: [],
      mobile: !!this.$isMobile.any(),
      count: 0,
      page: 0,
      limit: 10,
      selected: [],
      loading: false,
      statuses: {}
    }
  },
  created () {
    this.page = 'page' in this.$route.query ? parseInt(this.$route.query.page) : 1
    // получает данные из API для таблицы
    this.getData(`${this.$route.path.slice(11)}/`, this.page, true)
  },
  beforeRouteUpdate (to, from, next) {
    this.page = 'page' in to.query ? parseInt(to.query.page) : 1
    // получает данные из API для таблицы
    this.getData(`${to.path.slice(11)}/`, this.page)
    next()
  },
  computed: {
    filteredData () {
      const list = this.tdata
      // фильтруем вывод таблицы данных
      const mobileFields = ['pk', 'id', '__str__', 'owner', 'sign']
      const fields = this.mobile ? mobileFields : list[0] && this.$_.pull(Object.keys(list[0]), '__str__', 'app', 'model')
      return list.map(val => this.$_.pick(val, fields))
    }
  },
  methods: {
    setStatus (status, timeMs) {
      // на время устанавливает статус
      const id = this.$uuid()
      this.statuses[id] = status
      setTimeout(() => this.$delete(this.statuses, id), timeMs)
    },
    async deleteSelected () {
      // удаляет выбранные строки и обновляет данные
      const count = this.selected.length
      const pullSelected = [...this.selected]
      for (let i = 0; i < count; i++) {
        const objectModel = pullSelected.pop()
        const url = `${this.$route.params.app}/${this.$route.params.model}/${objectModel.pk || objectModel.id}/`
        await this.$axios.delete(url, { headers: this.$store.state.user.axiosHeaders })
          .then(res => {
            if (res.status === 204) {
              console.log(objectModel.pk + ' is deleted!')
              this.selected.splice(this.$_.findIndex(this.selected, objectModel), 1)
            }
          })
          .catch(err => {
            if (err.response.status === 403 && 'message' in err.response.data) {
              this.setStatus({
                class: 'is-danger',
                message: err.response.data.message
              }, 15000)
            } else console.log(err)
          })
      }
      this.getData(`${this.$route.params.app}/${this.$route.params.model}/`, this.page)
    },
    nextPage () {
      if (this.page * this.limit >= this.count) return
      this.page++
      this.toPage(this.page)
    },
    prevPage () {
      if (this.page - 2 < 0) return
      this.page--
      this.toPage(this.page)
    },
    toPage (page) {
      this.$router.push({ query: { page: page } })
    },
    addSign () {
      // вычленяет и добавляет поле подпись
      if (this.tdata[0] && 'document' in this.tdata[0]) {
        this.tdata = this.tdata.map(el => {
          el.sign = el.document.sign
          return el
        })
      }
    },
    getData (url, page, loading) {
      // получает данные из API для таблицы
      if (page < 1) throw new Error('Неверный запрос')
      this.loading = true && loading

      let params = {}

      // фильтруем параметры страницы
      params = this.$_.pick(this.$route.query, ['search', 'signed', 'success', 'unused'])

      Object.assign(params, {
        search: this.$route.query.search,
        limit: this.limit,
        offset: (page - 1) * this.limit,
        organization: this.$store.state.user.appointment.organization.name
      })

      // сброс данных перед запросом
      this.tdata = []
      this.count = 0
      try {
        this.$axios.get(url, { params, headers: this.$store.state.user.axiosHeaders })
          .then(res => {
            if ('results' in res.data && res.data.results.length > 0) {
              // все объекты передаем в таблицу
              this.tdata = res.data.results
              this.addSign()
              this.count = res.data.count
              this.loading = false && loading
            } else {
              if ('count' in res.data && res.data.count > 0) {
                // если страница указанная в запросе не содержит данных - редирект на последнюю страницу с данными
                const page = Math.ceil(res.data.count / this.limit)
                this.$router.push({ query: { page } })
                return
              }
              this.tdata = []
              this.count = 0
              this.loading = false && loading
            }
          })
          .catch(err => {
            if (err.response && [404].includes(err.response.status)) {
              console.log('page not found or access denied')
            } else console.log(err)
            this.loading = false && loading
          })
      } catch (error) {
        // ошибка URL
        console.log('неверный запрос')
        this.loading = false && loading
      }
    }
  }
}
</script>
